import { makeProfileNotificationSettingsURL, makeProfileNotificationsURL } from "../../../../utils/URL-profile/make-profile-notification-URL.js";
import { Alerts } from "../../../../utils/Alerts.js";
import { ErrorLoadingRetry } from "../../../../components/ErrorLoadingRetry.js";
import { NotificationsViewModel } from "../../viewmodels/NotificationsViewModel.js";
import { openNotification } from "../../open-notification.js";
import { NotificationListItem } from "../../components/NotificationListItem.js";
import { useEffect } from "react";
import { Button, Icon, Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { useSingleton } from "mvc-kit/react";
import { MdSettings } from "react-icons/md";
//#region src/modules/Notifications/screens/NotificationsSidebarScreen/index.tsx
function NotificationsSidebarScreen() {
	const vm = useSingleton(NotificationsViewModel);
	useEffect(() => {
		vm.fetchRecent();
	}, []);
	return /* @__PURE__ */ jsxs("div", {
		className: "flex h-full flex-col",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "border-border gap-xs px-base py-sm flex items-center border-b",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-color-strong grow font-semibold",
					children: "Notifications"
				}), /* @__PURE__ */ jsx(Button, {
					onClick: () => window.location.assign(makeProfileNotificationSettingsURL()),
					size: "xs",
					subtle: true,
					children: /* @__PURE__ */ jsx(Icon, {
						Icon: MdSettings,
						size: "sm"
					})
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "relative grow overflow-y-auto",
				children: [
					vm.state.loadingRecent && !vm.state.recentItems.length && /* @__PURE__ */ jsx("div", {
						className: "p-base relative",
						children: /* @__PURE__ */ jsx(Loading, { size: "lg" })
					}),
					!vm.state.loadingRecent && vm.state.errorRecent && !vm.state.recentItems.length && /* @__PURE__ */ jsx("div", {
						className: "p-base",
						children: /* @__PURE__ */ jsx(ErrorLoadingRetry, { onRetry: () => vm.fetchRecent() })
					}),
					!vm.state.loadingRecent && !vm.state.errorRecent && !vm.state.recentItems.length && /* @__PURE__ */ jsxs("div", {
						className: "text-color-subtle p-base text-center text-sm",
						children: [/* @__PURE__ */ jsx("div", {
							className: "text-color-strong font-semibold",
							children: "You're all caught up"
						}), /* @__PURE__ */ jsx("div", { children: "New notifications will show up here." })]
					}),
					vm.state.recentItems.map((item) => /* @__PURE__ */ jsx(NotificationListItem, {
						item,
						onOpen: openNotification,
						onResolve: () => vm.resolve(item.notificationId)
					}, item.notificationId)),
					vm.hasMore && /* @__PURE__ */ jsx("div", {
						className: "py-sm text-center",
						children: /* @__PURE__ */ jsx(Button, {
							loading: vm.state.loadingMore,
							onClick: () => vm.loadMore(),
							size: "sm",
							subtle: true,
							variant: "main",
							children: "Load more"
						})
					})
				]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "border-border px-sm py-xs flex items-center justify-between border-t",
				children: [/* @__PURE__ */ jsx(Button, {
					onClick: async () => {
						try {
							await vm.markRead();
						} catch {
							Alerts.error("There was a problem marking notifications read");
						}
					},
					size: "xs",
					subtle: true,
					variant: "main",
					children: "Mark all read"
				}), /* @__PURE__ */ jsx(Button, {
					onClick: () => window.location.assign(makeProfileNotificationsURL()),
					size: "xs",
					subtle: true,
					variant: "main",
					children: "View all →"
				})]
			})
		]
	});
}
//#endregion
export { NotificationsSidebarScreen };

//# sourceMappingURL=index.js.map